<template>
<div class="page-wrapper">
    <Header />
    <div class="content animated fadeInUp">
        <transition name="router-animation">
            <router-view />
        </transition>
    </div>
    <Footer />
</div>
</template>

<script>
import Vue from 'vue'
import Footer from '@/components/Footer/Footer';
import Header from '@/components/Header/Header';

export default Vue.extend({
    name: "Layout",
    components: { 
        Header,
        Footer 
    }
})
</script>
